import SvgIcons from "../../../../shared/components/svgIcons";
import StudentFeeSummary from "../components/studentFeeSummary";
import PaymentHistory from "../components/paymentHistory";
import PaymentSuccess from "../components/paymentSuccess/index";
import PaymentFailure from "../components/paymentFailure";
import PaymentReceipt from "../components/paymentReceipt";
import { link } from "fs";


const feeRoute = [{
  icon: SvgIcons.UsersIcon,
  path: "fee",
  link: "/fee",
  name: "Fee",
  element: "",
  index: 990,
  children: [
    {
      path: "feeDetails",
      element: <StudentFeeSummary />,
      name: "Fee Details",
      link: "/fee/feeDetails",
      icon: SvgIcons.UsersIcon,
    },
    {
      path: "paymentHistory",
      element: <PaymentHistory />,
      name: "Payment History",
      link: "/fee/paymentHistory",
      icon: SvgIcons.UsersIcon,
    },
    {
      path: "payment-receipt/:transactionID",
      element: <PaymentReceipt />,
      link: "/fee/payment-receipt/:transactionID",
      
    }

  ],
}, {
  path: "/payment/paymentSuccess",
  element: <PaymentSuccess />,
},
{
  path: "/payment/paymentFailure",
  element: <PaymentFailure />,
},

]
export default feeRoute;
